import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { Career } from '../models/career';

@Injectable()
export class CareersService {

  private _careersUrl = './api/careers/';

  constructor(private _http: HttpClient) { }

  get(): Observable<Array<Career>> {

    return this._http.get<Array<Career>>(this._careersUrl)
      .pipe(
        map(result => result),
        catchError(this.handleError)
      );

  }

  update(career: Career) {
    return this._http.put(this._careersUrl + career.id, career)
      .pipe(
        map((resp: Response) => resp),
        catchError(this.handleError)
      );
  }

  remove(id: number) {
    return this._http.delete(this._careersUrl + id).pipe(
      map((resp: Response) => resp),
      catchError(this.handleError)
    );
  }

  private handleError(err: HttpErrorResponse) {
    console.log(err.message);
    return Observable.throw(err.message);
  }
}
